import { z } from 'zod';
const med = z.string().min(1).max(1200);
export const payloadDerivationSchema = z.enum(['fixture_demo', 'live', 'partial_live']);
export const routingDimensionSchema = z.object({
    key: z.string().min(1).max(64),
    label: z.string().min(1).max(200),
    effective_summary: med,
});
export const effectiveRoutingPostureSchema = z.object({
    snapshot_version: z.string().min(1).max(64),
    headline: z.string().min(1).max(800),
    dimensions: z.array(routingDimensionSchema).min(1).max(24),
    byo_summary: z.string().max(1200).nullable(),
    routing_exception_hint: z.string().max(1200).nullable(),
    recommended_next_steps: z.array(z.string().min(1).max(800)).max(16),
});
export const policySourceClassSchema = z.enum([
    'platform_fixed',
    'tenant_bounded',
    'inherited_rule',
]);
export const policyChangeChannelSchema = z.enum([
    'member_request',
    'admin_only',
    'contact_codemerlin',
    'read_only',
]);
export const policyControlFacetSchema = z.object({
    key: z.string().min(1).max(64),
    label: z.string().min(1).max(200),
    effective_state: med,
    source_class: policySourceClassSchema,
    human_gate_required: z.boolean(),
    change_channel: policyChangeChannelSchema,
    audit_evidence_categories: z.array(z.string().min(1).max(200)).max(32).nullable().optional(),
});
export const budgetEnforcementModeSchema = z.enum([
    'advisory',
    'hard_cap',
    'not_configured',
    'unknown',
]);
export const budgetFreshnessSchema = z.enum(['live', 'stale', 'unavailable']);
export const utilizationBandSchema = z.enum(['low', 'near_soft', 'over_soft', 'blocked']);
export const budgetGuardrailProfileSchema = z.object({
    configured: z.boolean(),
    enforcement_mode: budgetEnforcementModeSchema,
    rolling_window_label: z.string().max(400).nullable(),
    utilization_summary: z.string().max(1200).nullable(),
    utilization_band: utilizationBandSchema.optional(),
    typical_steward_role: z.string().max(200).nullable(),
    freshness: budgetFreshnessSchema,
    notes: z.string().max(1200).nullable(),
});
export const subsystemDegradedSchema = z.object({
    budget: z.string().max(400).nullable().optional(),
    policy: z.string().max(400).nullable().optional(),
    routing: z.string().max(400).nullable().optional(),
});
export const aiControlsGovernSummarySchema = z.object({
    payload_derivation: payloadDerivationSchema,
    effective_routing_posture: effectiveRoutingPostureSchema,
    policy_controls: z.array(policyControlFacetSchema).min(4).max(32),
    budget_guardrails: budgetGuardrailProfileSchema.nullable(),
    degraded: subsystemDegradedSchema.nullable().optional(),
});
//# sourceMappingURL=ai-controls-summary.js.map